import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "60",
        height: "60",
        viewBox: "0 0 60 60"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.3333 60V54.4445H27.2223V42.7778C24.3148 42.1666 21.7268 40.9213 19.4583 39.0417C17.1898 37.162 15.5926 34.8148 14.6667 32C10.5371 31.537 7.06019 29.8194 4.23608 26.8472C1.41203 23.8749 0 20.3333 0 16.2222V12.6667C0 11.1296 0.541667 9.81942 1.625 8.73608C2.70833 7.65275 4.0185 7.11108 5.5555 7.11108H13.5556V0H46.4444V7.11108H54.4445C55.9815 7.11108 57.2917 7.65275 58.375 8.73608C59.4583 9.81942 60 11.1296 60 12.6667V16.2222C60 20.3333 58.588 23.8749 55.7639 26.8472C52.9398 29.8194 49.4629 31.537 45.3333 32C44.4074 34.8148 42.8102 37.162 40.5417 39.0417C38.2732 40.9213 35.6852 42.1666 32.7778 42.7778V54.4445H45.6667V60H14.3333ZM13.5556 26.1111V12.6667H5.5555V16.2222C5.5555 18.5926 6.3055 20.6805 7.8055 22.4861C9.30556 24.2916 11.2222 25.5 13.5556 26.1111ZM46.4444 26.1111C48.7778 25.5 50.6944 24.2916 52.1945 22.4861C53.6945 20.6805 54.4445 18.5926 54.4445 16.2222V12.6667H46.4444V26.1111Z",
            fill: props.fill || "#FFE766"
        })
    }));
};
export default Icon;
